import styled from 'styled-components';
import device from '../mediaQueries';

const ModalOverflow = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000000;
  opacity: 0.8;
`;

const ModalContent = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: 1000px;
  z-index: 1050;
  font-family: "Avenir Light", "Arial", sans-serif;
  font-size: 13px;
  overflow: auto;
  opacity: 1;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.3);
  transform: translate(-50%, -50%);
`;

const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  padding: 9px 15px;
  border-bottom: 1px solid #eee;
`;

const ModalTitle = styled.span`
  flex: 1;
  margin: 0;
  font-size: 15px;
  line-height: 30px;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: "Avenir Black", "Arial Black", sans-serif;
`;

const CloseButton = styled.button`
  flex: 0;
  margin-top: 2px;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  font-weight: bold;
  line-height: 18px;
  color: #000000;
  text-shadow: 0 1px 0 #ffffff;
  opacity: 0.2;
`;

const SizeGuideContent = styled.div`
  overflow-y: auto;
  max-height: 400px;
  padding: 15px;

  ${device.mobile`
    max-height: none;
  `};
`;

const SizeNotice = styled.div`
  margin: 30px 0;
`;

const SizeGuideTabs = styled.ul`
  & li:not(.active) a {
    color: #999;
  }
`;

const TabLink = styled.a`
  font-family: "Avenir Black", "Arial Black", sans-serif;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
`;

const SizeGuideTable = styled.table`
  ${device.mobile`
    width: 100%;
  `} & tr {
    height: 34px;
    ${device.mobile`
      width: 100%;
    `};
  }

  & tbody {
    ${device.mobile`
      width: 100%;
    `};
  }

  & td:first-child,
  & th:first-child {
    padding-left: 12px;
  }

  & td:last-child,
  & th:last-child {
    padding-right: 8px;
  }

  & td,
  & th {
    padding-left: 0px;
    padding-right: 0px;
    ${device.mobile`
      padding-left: 8px;
      padding-right: 8px;
      white-space: nowrap;
    `};
  }

  & thead {
    font-family: "Avenir Black", "Arial Black", sans-serif;
  }

  & tbody tr:nth-child(odd) {
    background-color: #eceeef;
  }
`;

const HeadCell = styled.td`
  font-weight: bold;
  font-family: "Avenir Black", "Arial Black", sans-serif;
  font-size: 15px;

  text-align: ${({ leftAligned }) => (leftAligned ? 'left' : 'center')};
`;

const BodyCell = styled.td`
  text-align: ${({ leftAligned }) => (leftAligned ? 'left' : 'center')};
`;

const GuideSectionTitle = styled.div`
  color: rgb(0, 0, 0);
  font-size: 15px;
  font-family: "Avenir Black", "Arial Black", sans-serif;
  letter-spacing: 1px;
  text-transform: uppercase;
  user-select: none;
  padding: 0.5em 0.2em 0.5em 0px;
  margin-bottom: 1em;
`;

const SlidePrompt = styled.div`
  color: #9b9b9b;
  text-align: right;
  font-weight: 300;
  margin-right: 0.5em;
  margin-bottom: 1em;
`;

const GuideSection = styled.div`
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ScrollableContainer = styled.div`
  overflow-x: auto;
`;

const ChangeDepartment = styled.div`
  align-items: center;
  color: #999999;
  display: flex;
  justify-content: center;
  text-decoration: underline;
  font-family: "Avenir Light", "Arial", sans-serif;
  font-size: 15px;
  padding: 5px 30px 0 0;
  ${device.mobile`
    padding: 0;
  `};
  cursor: pointer;
`;

export {
  BodyCell,
  HeadCell,
  ModalContent,
  ModalOverflow,
  ModalHeader,
  ModalTitle,
  CloseButton,
  SizeNotice,
  TabLink,
  ScrollableContainer,
  SizeGuideContent,
  SizeGuideTable,
  SizeGuideTabs,
  SlidePrompt,
  GuideSectionTitle,
  GuideSection,
  ChangeDepartment
};
